import './App.css';
import AllRoute from '@/router/index'
import React from 'react';

function App() {
  return (
    <div className="App">
      <AllRoute/>
    </div>
  );
}

export default App;
